export default {
	init() {
		const $form = $('#tr-ng-staropramen-form')
		if ($form.length === 0) return

		const formEl = $form.get(0)
		const actionInput = formEl ? formEl.querySelector('input[name="action"]') : null
		if (!actionInput || actionInput.value !== 'tr_save_ng_staropramen') return

		$form.on('submit', function(e) {
			e.preventDefault()

			if (!formEl.checkValidity()) {
				formEl.reportValidity()
				return
			}

			const $submitBtn = $form.find('button[type="submit"]')
			$submitBtn.prop('disabled', true)

			const formData = new FormData(this)
			const form_error_element = $form.find('.form-response.error')
			const getErrorMessage = (payload, fallback = 'Napaka pri shranjevanju. Osvežite stran in poskusite znova.') => {
				if (typeof payload === 'string' && payload.trim() !== '') {
					return payload
				}

				if (payload && typeof payload === 'object') {
					if (typeof payload.error === 'string' && payload.error.trim() !== '') {
						return payload.error
					}

					if (typeof payload.message === 'string' && payload.message.trim() !== '') {
						return payload.message
					}
				}

				return fallback
			}

			$.ajax({
				url: my_ajax_object.ajax_url,
				type: 'POST',
				data: formData,
				processData: false,
				contentType: false,
				dataType: 'json',
				success: function (response) {
					if (response && response.success) {
						form_error_element
							.text('Recept je oddan. Hvala za sodelovanje v nagradni igri!')
							.removeClass('hidden text-red border-red')
							.addClass('success text-blue border-blue')
							.show()

						setTimeout(function() {
							window.location.href = response.data.redirect
						}, 1200)
					} else {
						const msg = getErrorMessage(response?.data, 'Napaka pri shranjevanju.')
						form_error_element
							.text(msg)
							.removeClass('hidden success text-blue border-blue')
							.addClass('text-red border-red')
						$submitBtn.prop('disabled', false)
					}
				},
				error: function (jqXHR) {
					let msg = getErrorMessage(jqXHR?.responseJSON?.data, '')
					if (!msg) {
						msg = getErrorMessage(jqXHR?.responseJSON?.message, '')
					}
					if (!msg) {
						msg = 'Napaka pri shranjevanju. Osvežite stran in poskusite znova.'
					}

					form_error_element
						.text(msg)
						.removeClass('hidden success text-blue border-blue')
						.addClass('text-red border-red')
					$submitBtn.prop('disabled', false)
				}
			})
		})
	}
}
